var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "mail_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M60 8.727v46.546H4V8.727zm-28 25.55L8 21.188v30.086h48V21.187zM8 16.63 32 29.72l24-13.09v-3.903H8z"
  })));
};
export { SvgMail as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNjAgOC43MjcwNVY1NS4yNzI5SDRWOC43MjcwNUg2MFpNMzIgMzQuMjc3OEw4IDIxLjE4N1Y1MS4yNzI5SDU2VjIxLjE4N0wzMiAzNC4yNzc4Wk04IDE2LjYyOTRMMzIgMjkuNzIwMkw1NiAxNi42Mjk0VjEyLjcyNzFIOFYxNi42Mjk0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";